import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserTeam } from 'shared';

export interface UserTeamSelectionState {
    userTeam: UserTeam | null;
    target: string;
}

@Injectable({ providedIn: 'root' })
export class UserTeamSelectorSidebarService {
    public readonly selectionChanged = new Subject<UserTeamSelectionState>();
    public readonly selectionSubmitted = new Subject<UserTeamSelectionState>();

    public updateSelection(state: UserTeamSelectionState): void {
        this.selectionChanged.next(state);
    }

    public submitSelection(state: UserTeamSelectionState): void {
        this.selectionSubmitted.next(state);
    }

    public getSelectedIdsForData<TEntity extends { id: string; assigneeId?: string; teamId?: string }>(
        rows: Array<TEntity>,
        selectedRowIds: Array<string>
    ): { userId: string | null; teamId: string | null } {
        const selected = rows.filter((task) => selectedRowIds.includes(task.id));
        const selectedAssigneeIds = new Set(selected.map((entity) => entity.assigneeId).filter(Boolean));
        const selectedTeamIds = new Set(selected.map((entity) => entity.teamId).filter(Boolean));

        const userId = [...selectedAssigneeIds][0] ?? null;
        const teamId = [...selectedTeamIds][0] ?? null;

        return { userId, teamId };
    }
}
